/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  @include slotted-margins("*:not([slot])");
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.#{$prefix}error-message {
  background: v(backgroundColor);
  box-sizing: border-box;
  padding: 48px;
  position: relative;
  width: 100%;
  display: none;

  &::before {
    content: "";
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    border-left: 8px solid v(leftBorderColor);
  }

  @include for-size(desktop) {
    padding: 40px;
  }

  @include for-size(tablet) {
    padding: 32px;
  }

  @include for-size(phone) {
    padding: 24px;
  }

  &.#{$prefix}fixed {
    position: fixed;
    left: 0;
    z-index: 300;
  }

  &.#{$prefix}bottom {
    bottom: 0;
  }

  &.#{$prefix}top {
    top: 0;
  }

  &.#{$prefix}visible {
    display: flex;
    flex-direction: column;
    opacity: 1;
    animation: fadeIn ease 0.5s;
  }

  &.#{$prefix}hiding {
    opacity: 0;
    animation: fadeOut ease 0.5s;
  }

  &.#{$prefix}hide-closing-x {
    padding-top: 32px;
  }

  &.#{$prefix}hide-border::before {
    border-left: none;
  }
}

.#{$prefix}error-message-content {
  box-sizing: border-box;
  position: relative;
  max-width: $content-max-width-desktop-l;
  margin: 0 auto;
  width: 100%;

  @include for-size(desktop-or-smaller) {
    max-width: $content-max-width-desktop;
  }
}

.#{$prefix}error-message-headline-wrapper {
  margin-bottom: 40px;
  display: flex;
  gap: 12px;

  @include for-size(desktop) {
    margin-bottom: 32px;
  }

  @include for-size(tablet-or-smaller) {
    margin-bottom: 24px;
  }

  .#{$prefix}error-message-headline {
    padding-right: 48px;
    min-height: 32px;

    @include for-size(phone) {
      padding-right: 0;
    }
  }
}

.#{$prefix}error-message-close {
  position: absolute;
  top: 48px;
  right: 48px;
  fill: v(contentColor);
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  z-index: 1;

  @include for-size(desktop) {
    top: 40px;
    right: 40px;
  }

  @include for-size(tablet) {
    top: 32px;
    right: 32px;
  }

  @include for-size(phone) {
    top: 0;
    right: 0;
    align-self: flex-end;
    position: relative;
  }
}

::slotted(eon-ui-link) {
  --contentHoverColor: var(--linkHoverColor) !important;
  --contentFocusColor: var(--linkHoverColor) !important;
}

::slotted(eon-ui-linkList) {
  --linklistHoverColor: var(--linkHoverColor) !important;
  --contentFocusColor: var(--linkHoverColor) !important;
}
